import type { VendorHubEnvironment } from '@vendorhub/shared/config';

export const environment: VendorHubEnvironment = {
  production: false,
  apiBaseUrl: 'http://localhost:5000',
  appBaseUrl: 'http://localhost:4200',
  defaultLocale: 'en',
  supportedLocales: ['en', 'hi', 'gu'] as const,
  sentryDsn: null,
  featureFlags: {
    incrementalHydration: true,
  },
};
